import React from "react";
import Frequent from "../components/Doctor/Account/Frequent";
import Profile from "../components/Doctor/Account/Profile";
import Analytics from "../components/Doctor/Account/Analytics";
import Records from "../components/Doctor/Account/Records";
import Subscription from "../components/Doctor/Account/Subscription";
import Database from "../components/Admin/Profile/Database/Database";
import Integration from "../components/Admin/Profile/Integration";
import CreatePartners from "../components/Admin/Profile/CreatePartners";
import Doctor from "../components/Admin/Partners/Doctor/Doctor";
import Store from "../components/Admin/Partners/Store/Store";
import DoctorRequests from "../components/Admin/Partners/Doctor/DoctorRequests";
import Product from "../components/Admin/Inventory/Products";
import Stock from "../components/Admin/Inventory/Stock";
import Requests from "../components/Admin/Inventory/Requests";
import StoreStock from "../components/Store/StoreStock";
import StoreProducts from "../components/Store/StoreProducts";
import StoreDashboard from "../components/Admin/Store_Dashboard/StoreDashboard";
import Vtable from "../components/Admin/Inventory/Vtable";
import Drugs from "../components/Admin/Inventory/Drugs/Drugs";
import Manufacturers from "../components/Admin/Inventory/Manufacturers/Manufacturers";

export const productTypeValues = [
  "Tablet",
  "Capsules",
  "Syrup",
  "Baby Drops",
  "Eye/Ear Drops",
  "Injectables",
  "Insulin",
  "Powder",
  "Cream",
  "Ointment",
  "Surgical",
  "Inhaler",
  "Nasal Spray",
  "Suppository",
  "Suspension",
  "Patch",
  "Gel",
  "Other",
];

export const letters = ["", "A", "B", "C", "D", "E"];
export const foodToggleValues = ["A/F", "B/F", "W/F", "HS", "Anytime", "PRN", "AD", "X"];
export const foodToggleLabels = {
  "A/F": "A/F (After Food)",
  "B/F": "B/F (Before Food / Empty Stomach)",
  "W/F": "W/F (With Food)",
  "HS": "HS (At Bedtime / Before Sleep)",
  "Anytime": "Anytime (Irrespective of Food)",
  "PRN": "PRN (Whenever Required / SOS)",
  "AD": "AD (As Directed / As Instructed)",
  "X": "None / Not Specified",
};

export const periodicFrequencyOptions = [
  { label: "Once a week", value: "Once a week", intervalDays: 7 },
  { label: "Alternate Days", value: "Alternate Days", intervalDays: 2 },
  { label: "Twice a week", value: "Twice a week", intervalDays: 3.5 },
  { label: "Every 15 days", value: "Every 15 days", intervalDays: 15 },
  { label: "Once a month", value: "Once a month", intervalDays: 30 },
  { label: "Single Dose / Stat", value: "Single Dose", intervalDays: 0 },
  { label: "Every 3 days", value: "Every 3 days", intervalDays: 3 },
  { label: "Every 5 days", value: "Every 5 days", intervalDays: 5 },
];

export const quickDosageNoteSuggestions = [
  "Apply externally",
  "Instill 1 drop in each eye",
  "Gargle with warm water",
  "Dissolve in 100ml water",
  "1 puff morning & night",
  "Take with warm milk"
];

export const buttonData = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Clinic",
    value: "isClinic",
  },
  {
    label: "Collect",
    value: "isCollect",
  },
  {
    label: "Address",
    value: "isAddress",
  },
];

export const accountTabs = [
  { name: "Profile", content: <Profile /> },
  { name: "Analytics", content: <Analytics /> },
  { name: "Frequent", content: <Frequent /> },
  { name: "Records", content: <Records /> },
  { name: "Subscription", content: <Subscription /> },
];

export const addressType = [
  {
    name: "Home",
    value: "home",
  },
  {
    name: "Work",
    value: "work",
  },
  {
    name: "Other",
    value: "other",
  },
];

export const paymentType = [
  {
    name: "Cash",
    value: "cash",
  },
  {
    name: "Card",
    value: "card",
  },
  {
    name: "UPI",
    value: "upi",
  },
];

export const receiptPaymentModes = [
  { name: "Cash", value: "Cash" },
  { name: "Card", value: "Card" },
  { name: "UPI", value: "UPI" },
  { name: "Unpaid", value: "Unpaid" },
  { name: "Waived", value: "Waived" },
  { name: "Other", value: "Other" },
];

export const deliveryLocation = [
  {
    name: "Clinic",
    value: "isClinic",
    // icon: <Clinic />,
  },
  {
    name: "Collect",
    value: "isCollect",
    // icon: <Collect />,
  },
  {
    name: "Address",
    value: "isAddress",
    // icon: <Address />,
  },
];

export const AdminProfileTabs = [
  { name: "Listing", content: <CreatePartners /> },
  { name: "Integration", content: <Integration /> },
  { name: "Database", content: <Database /> },
];

export const AdminStoreTabs = [{ name: "Orders", content: <StoreDashboard /> }];

export const UserCreateMenu = [
  { name: "Doctor Requests", content: <DoctorRequests /> },
  { name: "Doctor", content: <Doctor /> },
  { name: "Store", content: <Store /> },
];

export const InventoryMenu = [
  { name: "Products", content: <Product /> },
  { name: "Stock", content: <Stock /> },
  { name: "Drugs", content: <Drugs /> },
  { name: "Manufacturers", content: <Manufacturers /> },
  { name: "V Table", content: <Vtable /> },
  { name: "Requests", content: <Requests /> },
];

export const DatabaseBtn = [
  {
    label: "Orders",
    value: "orders",
  },
  {
    label: "Customers",
    value: "customers",
  },
  {
    label: "Statistics",
    value: "statistics",
  },
];

export const paymentOptions = [
  { label: "Bank Account", value: "bank" },
  { label: "UPI Account", value: "upi" },
];

export const PublishedRecordBtn = [
  {
    label: "Records",
    value: "records",
  },
  {
    label: "Publish New",
    value: "publishNew",
  },
  {
    label: "Frequent",
    value: "frequent",
  },
];

export const StoreInventoryMenu = [
  { name: "Stock", content: <StoreStock /> },
  { name: "Products", content: <StoreProducts /> },
];

export const OrderFilterButtons = [
  {
    label: "All (F1)",
    value: "all",
    count: "00",
  },
  {
    label: "Clinic (F2)",
    value: "clinic",
    count: "00",
  },
  {
    label: "Collect (F3)",
    value: "collect",
    count: "00",
  },
  {
    label: "Address (F4)",
    value: "address",
    count: "00",
  },
];

export const OrderStatusButtons = [
  {
    label: "All",
    value: "all",
    count: "00",
  },
  {
    label: "Accepted",
    value: "accept",
    count: "00",
  },
  {
    label: "Packed",
    value: "packed",
    count: "00",
  },
  {
    label: "Dispatched",
    value: "dispatched",
    count: "00",
  },
  {
    label: "Delivered",
    value: "delivered",
    count: "00",
  },
  {
    label: "Cancelled",
    value: "cancelled",
    count: "00",
  },
];

export const extentions = {
  "Tablet": { extention: "tab", calc: true, quantity: [0.25, 0.5, 1, 1.5, 2, 3], cycle: [0, 0.5, 1, 1.5, 2, 3], defaultDose: 1 },
  "Capsules": { extention: "cap", calc: true, quantity: [0.5, 1, 1.5, 2, 3], cycle: [0, 1, 2], defaultDose: 1 },
  "Syrup": { extention: "ml", calc: true, quantity: [1, 2, 2.5, 3, 4, 5, 7.5, 10, 15, 20, 30], cycle: [0, 2.5, 5, 10, 15], defaultDose: 5 },
  "Baby Drops": { extention: "ml", calc: true, quantity: [0.1, 0.2, 0.25, 0.3, 0.4, 0.5, 0.6, 0.75, 0.8, 1, 1.5, 2], cycle: [0, 0.25, 0.5, 1, 1.5, 2], defaultDose: 0.5 },
  "Eye/Ear Drops": { extention: "drops", uomExt: "ml", calc: false, quantity: [1, 2, 3, 4], cycle: [0, 1, 2, 3, 4], defaultDose: 1 },
  "Injectables": { extention: "amp/vial", calc: true, quantity: [0.5, 1, 2], cycle: [0, 1, 2], defaultDose: 1 },
  "Insulin": { extention: "IU", uomExt: "ml", calc: true, quantity: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 15, 16, 18, 20, 22, 24, 25, 26, 28, 30, 32, 34, 35, 36, 38, 40, 45, 50, 60], cycle: [0, 2, 4, 6, 8, 10, 12, 14, 16, 20], defaultDose: 10 },
  "Powder": { extention: "sachet", uomExt: "gm", calc: false, quantity: [0.5, 1, 1.5, 2], cycle: [0, 0.5, 1, 2], defaultDose: 1 },
  "Cream": { extention: "apply", uomExt: "gm", calc: false, quantity: [1], cycle: [0, 1], defaultDose: 1 },
  "Ointment": { extention: "apply", uomExt: "gm", calc: false, quantity: [1], cycle: [0, 1], defaultDose: 1 },
  "Surgical": { extention: "unit", calc: false, quantity: [1], cycle: [0, 1], defaultDose: 1 },
  "Inhaler": { extention: "puffs", calc: false, quantity: [1, 2, 3, 4], cycle: [0, 1, 2], defaultDose: 1 },
  "Nasal Spray": { extention: "sprays", calc: false, quantity: [1, 2], cycle: [0, 1, 2], defaultDose: 1 },
  "Suppository": { extention: "supp", calc: true, quantity: [1, 2], cycle: [0, 1, 2], defaultDose: 1 },
  "Suspension": { extention: "ml", calc: true, quantity: [1, 2, 2.5, 3, 4, 5, 7.5, 10, 15, 20, 30], cycle: [0, 2.5, 5, 10, 15], defaultDose: 5 },
  "Patch": { extention: "patch", calc: true, quantity: [1], cycle: [0, 1], defaultDose: 1 },
  "Gel": { extention: "apply", uomExt: "gm", calc: false, quantity: [1], cycle: [0, 1], defaultDose: 1 },
  "Other": { extention: "", calc: false, quantity: [0.5, 1, 1.5, 2, 2.5, 3, 4, 5], cycle: [0, 0.5, 1, 2], defaultDose: 1 },
}
